import React, { PropTypes } from 'react';
import { Loader as RLoader } from 'react-loaders';

const Loader = ({ isVerticalCenter, style }) => {
  return (
    isVerticalCenter ?
    <div className="myloader v-center">
      <div className="text-center">
        {/* <RLoader active type="ball-pulse-sync" color="#9575CD" /> */}
        <RLoader active type="line-scale" color="#2BCCB1" />
      </div>
    </div>
    :
    <div className="text-center" style={style}>
      {/* <RLoader active type="ball-pulse-sync" color="#9575CD" /> */}
      <RLoader active type="line-scale" color="#2BCCB1" />
    </div>
  );
}

Loader.propTypes = {
  isVerticalCenter: PropTypes.bool,
};

export default Loader;
